import React from 'react';
import { withRouter } from 'react-router-dom';

import UserAuthPage from 'dpl/UserAuth/components/UserAuthPage';

function UserAuthPageContainer(props) {
  return <UserAuthPage {...props} />;
}

export default withRouter(UserAuthPageContainer);
